/* 
  Shokz Quiz 组件说明
  - 职责：管理 Quiz 的步骤流转、选项记录、结果推荐与提交
  - 显示控制：通过根节点 data-step / data-step-part 与 CSS 控制各 Part 显示；JS 不直接操控样式
  - 状态：
    step        当前步骤（1~4）
    subStep     Step2 的分支（1: Sport, 2: Lifestyle/Multi, 3: Work）
    history     供返回使用的栈
    answers     记录每步所选 data-index
    labels      记录规范化文本，用于映射查找
    rawLabels   记录原始文本（提交给后端）
  - 映射：productMap（Step1→Step2→Step3需求→产品名），handleMap（产品名→句柄）
  - 结果：根据映射激活对应 data-handle 的产品卡（默认回退首项）
  - 提交：拦截订阅表单，按接口要求发送 email、quiz_habit、quiz_scenario、quiz_needs、quiz_varientid；Work 路径将 Step2 放入 quiz_needs，quiz_scenario 置空；请求头携带 X-Site（来自表单 data-site）
*/
if (!customElements.get('quiz-section')) {
    customElements.define(
        'quiz-section',
        class QuizSection extends HTMLElement {
            constructor() {
                super();
                this.quizTitls = {
                    "1": "Where do you mainly use your headphones?",
                    "2_1": "What types of activities do you do most often?",
                    "2_2": "In everyday use, which activity do you use your headphones for most often?",
                    "2_3": "At work, what matters most to you?",
                    "3": "What is your top priority when choosing headphones?",
                    "4": "Based on your answers, we recommend:"
                };

                this.state = {
                    step: 1,
                    subStep: null,
                    history: [],
                    answers: {},
                    labels: {}
                };
                this.DEBUG = true;

                this.handleMap = {
                    "openrun pro2": "openrun-pro2",
                    "openfit 2+": "openfit2-series",
                    "openrun": "openrun",
                    "openswim pro": "openswim-pro",
                    "openswim": "openswim",
                    "openfit pro": "openfit-pro",
                    "opendots one": "opendots-one",
                    "openfit air": "openfit-air",
                    "opencomm 2 2025": "opencomm22025upgrade"
                };

                this.productMap = {
                    "sport": {
                        "run": {
                            "sound quality": "openrun pro2",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "sweat resistance": "openrun pro2",
                            "price / value": "openrun"
                        },
                        "cycling": {
                            "sound quality": "openrun pro2",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "sweat resistance": "openrun pro2",
                            "price / value": "openrun"
                        },

                        "traning / gym": {
                            "sound quality": "openrun pro2",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "sweat resistance": "openrun pro2",
                            "price / value": "openrun"
                        },
                        "hiking / climbing": {
                            "sound quality": "openrun pro2",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "sweat resistance": "openrun pro2",
                            "price / value": "openrun"
                        },

                        "swimming": {
                            "land & water use": "openswim pro",
                            "built-in mp3": "openswim pro",
                            "price / value": "openswim"
                        }
                    },

                    "lifestyle": {
                        "music / podcasts": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "opendots one",
                            "secure fit": "openfit 2+",
                            "price / value": "openfit air"
                        },
                        "light exercise / walking / gym": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "price / value": "openrun",
                            "sweat resistance": "openrun pro2"
                        },
                        "running / cycling": {
                            "sound quality": "openrun pro2",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "price / value": "openrun",
                            "sweat resistance": "openrun pro2"
                        },
                        "mobile calls": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "opendots one",
                            "secure fit": "openfit 2+",
                            "price / value": "openfit air"
                        },
                        "reading / office work": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "opendots one",
                            "secure fit": "openfit 2+",
                            "price / value": "openfit air"
                        }
                    },

                    "multi-scenario use": {
                        "music / podcasts": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "opendots one",
                            "secure fit": "openfit 2+",
                            "price / value": "openfit air"
                        },
                        "light exercise / walking / gym": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "price / value": "openrun",
                            "sweat resistance": "openrun pro2"
                        },
                        "running / cycling": {
                            "sound quality": "openrun pro2",
                            "all-day comfort": "openfit 2+",
                            "secure fit": "openrun pro2",
                            "price / value": "openrun",
                            "sweat resistance": "openrun pro2"
                        },
                        "mobile calls": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "opendots one",
                            "secure fit": "openfit 2+",
                            "price / value": "openfit air"
                        },
                        "reading / office work": {
                            "sound quality": "openfit pro",
                            "all-day comfort": "opendots one",
                            "secure fit": "openfit 2+",
                            "price / value": "openfit air"
                        }
                    },

                    "work": {
                        "all-day comfort": "opencomm 2 2025",
                        "clear calling": "opencomm 2 2025",
                        "noise reduction": "openfit pro"
                    }
                };

                this.normalize = (str) => {
                    return (str || "")
                        .toLowerCase()
                        .replace(/[&\/\-_]/g, ' ')
                        .replace(/\s+/g, ' ')
                        .replace(/[，、]/g, ',')
                        .trim();
                };
            }

            connectedCallback() {
                // Initialize DOM references
                this.dom = {
                    title: this.querySelector('.quiz-section-title'),
                    progressBarItems: this.querySelectorAll('.quiz-section-progress_bar-item'),
                    parts: this.querySelectorAll('.quiz-section-option-part'),
                    nextBtn: this.querySelector('.quiz-section-button_next'),
                    backBtn: this.querySelector('.quiz-section-button_back'),
                    restartBtn: this.querySelector('.quiz-section-button_restart'),
                    closeBtn: this.querySelector('.quiz-section-close_button'),
                    linkBtn: this.querySelector('.quiz-section-button_link'),
                    resultProducts: this.querySelectorAll('.quiz-section-result-product-item'),
                    subscribeContainer: this.querySelector('.quiz-section-result-subscribe-box'),
                    subscribeForm: this.querySelector('.quiz-section-result-subscribe-form')
                };

                this.bindEvents();
                // Initialize state based on HTML or default
                this.updateUI();

                const dialogOpenBtn = document.querySelector('.section-collection-banner .button-text');
                if (dialogOpenBtn) {
                    dialogOpenBtn.addEventListener('click', () => {
                        this.classList.add('active');
                    });
                }
                this.dom.closeBtn.addEventListener('click', () => {
                    if (this.classList.contains('active')) {
                        this.classList.remove('active');
                    }
                });
            }

            capitalizeWords(str) {
                return str
                    .split(' ') // 按空格分割字符串
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // 转换每个单词
                    .join(' '); // 重新组合成字符串
            }

            ga4SelectContent(contentType, contentName, buttonName) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event_parameters: null });
                window.dataLayer.push({
                    event: 'ga4Event',
                    event_name: 'select_content',
                    event_parameters: {
                        content_type: contentType,
                        content_name: contentName,
                        button_name: buttonName
                    }
                });
            }

            quiz_ga4_deal_with_discount(
                product_item,
                buttom_name,
                event_name,
                discount = 0,
            ) {
                let $v_item_name = "";
                let $v_item_variant = "";
                let $v_item_category = "";
                let $v_item_category2 = "Standard";
                if (product_handle_map.has(product_item[0])) {
                    $v_item_name = product_handle_valueMap[product_item[0]][0];
                    $v_item_variant = product_handle_valueMap[product_item[0]][1];
                    $v_item_category = product_handle_valueMap[product_item[0]][2];
                    $v_item_category2 = product_handle_valueMap[product_item[0]][3];
                }

                let event_parameters_before = {
                    item_list_id: this.capitalizeWords(product_item[3]),
                    item_list_name: "quiz_recommend",
                    currency: "AUD",
                    value: Number(product_item[9].split("$").join("").replace(",", "")),
                    items: [
                        {
                            item_id: product_item[0],
                            item_name: $v_item_name,
                            index: product_item[2],
                            item_list_id: this.capitalizeWords(product_item[3]),
                            item_list_name: this.capitalizeWords(product_item[4]),
                            item_category: $v_item_category,
                            item_category2: $v_item_category2,
                            item_category3: product_item[6].replace("Default Title", "none"),
                            item_variant: $v_item_variant,
                            item_brand: "SHOKZ",
                            price: Number(product_item[9].split("$").join("").replace(",", "")),
                            quantity: Number(product_item[10]),
                            currency: "AUD",
                            discount: discount,
                        },
                    ],
                };

                if (buttom_name) {
                    event_parameters_before.button_name = buttom_name;
                }

                window.dataLayer.push({ event_parameters: null });
                window.dataLayer.push({
                    event: "ga4Event",
                    event_name: event_name,
                    event_parameters: event_parameters_before,
                });
            }

            trackBuyCardClick($trigger, source, event_name) {
                const $buyCard = $trigger.closest(".quiz-section-result-product-item");
                if (!$buyCard.length) return;
                // 产品数据
                let productData = $trigger.data("product-data") || $buyCard.data("product-data");

                if (!productData) return;
                const product_item = productData.split("::");
                const discountRaw = $buyCard.data("discount");
                const discountNum = Number(discountRaw);
                const discount = Number.isFinite(discountNum) ? Number(discountNum.toFixed(2)) : 0;

                // GA4
                const buttom_name = source === "link" ? "Buy Now" : (source === "picture" ? "picture" : source);
                this.quiz_ga4_deal_with_discount(product_item, buttom_name, event_name, discount);

            }


            handleOptionClick(e) {
                const button = e.currentTarget;
                const part = button.closest('.quiz-section-option-part');

                // Ensure we only interact with the visible part
                // CSS controls visibility, so if we can click it, it's likely visible.
                // But double check just in case of weird propagation or overlap.
                if (!part) return;

                // Scoped selection: Remove 'selected' only from buttons in this part
                part.querySelectorAll('.quiz-section-option-button').forEach(btn => btn.classList.remove('selected'));
                button.classList.add('selected');

                // Store answer
                const stepKey = this.state.step === 2 ? `2_${this.state.subStep}` : `${this.state.step}`;
                this.state.answers[stepKey] = button.dataset.index;

                const textEl = button.querySelector('.quiz-section-option-button-text');
                const labelRaw = textEl ? textEl.textContent : button.getAttribute('data-needs') || button.textContent;
                const label = this.normalize(labelRaw);
                this.state.labels[stepKey] = label;
                if (!this.state.rawLabels) this.state.rawLabels = {};
                this.state.rawLabels[stepKey] = (labelRaw || '').trim();

                if (this.state.step === 1 && part.classList.contains('quiz-section-option-part-1')) {
                    this.ga4SelectContent('quiz_step1', (labelRaw || '').trim(), '');
                }

                if (this.state.step === 2 && part.classList.contains(`quiz-section-option-part-2-${this.state.subStep}`)) {
                    this.ga4SelectContent('quiz_step2', (labelRaw || '').trim(), '');
                }

                if (this.state.step === 3 && part.classList.contains('quiz-section-option-part-3')) {
                    this.ga4SelectContent('quiz_step3', (labelRaw || '').trim(), '');
                }

                this.updateNextButtonState();

                // console.log(`[Quiz] 当前步骤: ${this.state.step}, 选择 -> 键: ${stepKey}, 标签: ${labelRaw}, 索引: ${button.dataset.index}`);
            }

            nextStep() {
                // Validation
                if (this.state.step < 4) {
                    const currentPart = this.getCurrentPart();
                    if (currentPart) {
                        const selected = currentPart.querySelector('.quiz-section-option-button.selected');
                        if (!selected) {
                            // You might want to show a tooltip or error message here
                            return;
                        }
                    }
                }

                if (this.state.step === 1) {
                    const contentName = (this.state.rawLabels && this.state.rawLabels['1']) ? this.state.rawLabels['1'] : '';
                    this.ga4SelectContent('quiz_step1', contentName, 'Next');
                }

                if (this.state.step === 2) {
                    const contentName = (this.state.rawLabels && this.state.rawLabels[`2_${this.state.subStep}`]) ? this.state.rawLabels[`2_${this.state.subStep}`] : '';
                    this.ga4SelectContent('quiz_step2', contentName, 'Next');
                }

                if (this.state.step === 3) {
                    const contentName = (this.state.rawLabels && this.state.rawLabels['3']) ? this.state.rawLabels['3'] : '';
                    this.ga4SelectContent('quiz_step3', contentName, 'Next');
                }

                // Push history
                this.state.history.push({
                    step: this.state.step,
                    subStep: this.state.subStep
                });

                // Logic to determine next step
                if (this.state.step === 1) {
                    const ans = this.state.answers['1'];
                    this.state.step = 2;
                    if (ans === '1') this.state.subStep = '1';      // Sport
                    else if (ans === '2') this.state.subStep = '2'; // Lifestyle
                    else if (ans === '3') this.state.subStep = '3'; // Work
                    else if (ans === '4') this.state.subStep = '2'; // Multi-scenario -> Step 2-2
                    else {
                        // Fallback -> Skip to Step 3
                        this.state.step = 3;
                        this.state.subStep = null;
                    }
                } else if (this.state.step === 2) {
                    const step1Label = this.state.labels['1'];
                    const isWork = step1Label === this.normalize('Work');
                    if (isWork) {
                        this.state.step = 4;
                        this.state.subStep = null;
                        this.calculateAndShowResult();
                    } else {
                        this.state.step = 3;
                        this.state.subStep = null;
                        this.filterStep3Options();
                    }
                } else if (this.state.step === 3) {
                    this.state.step = 4;
                    this.state.subStep = null;
                    this.calculateAndShowResult();
                }

                this.updateUI();
            }

            prevStep() {
                if (this.state.step === 3) {
                    const contentName = (this.state.rawLabels && this.state.rawLabels['3']) ? this.state.rawLabels['3'] : '';
                    this.ga4SelectContent('quiz_step3', contentName, 'Back');
                }
                if (this.state.step === 2) {
                    const contentName = (this.state.rawLabels && this.state.rawLabels[`2_${this.state.subStep}`]) ? this.state.rawLabels[`2_${this.state.subStep}`] : '';
                    this.ga4SelectContent('quiz_step2', contentName, 'Back');
                }
                if (this.state.history.length === 0) return;
                const prevState = this.state.history.pop();
                this.state.step = prevState.step;
                this.state.subStep = prevState.subStep;
                this.updateUI();
            }

            restart() {
                if (this.state.step === 4 && this.dom.restartBtn) {
                    const buttonName = (this.dom.restartBtn.getAttribute('aria-label') || this.dom.restartBtn.textContent || '').trim();
                    this.ga4SelectContent('quiz_step4', 'quiz_recommend', buttonName);
                }
                this.state.step = 1;
                this.state.subStep = null;
                this.state.history = [];
                this.state.answers = {};
                this.state.labels = {};
                this.state.rawLabels = {};
                this.querySelectorAll('.selected').forEach(el => el.classList.remove('selected'));
                this.updateUI();
            }

            getCurrentPart() {
                if (this.state.step === 1) return this.querySelector('.quiz-section-option-part-1');
                if (this.state.step === 2) return this.querySelector(`.quiz-section-option-part-2-${this.state.subStep}`);
                if (this.state.step === 3) return this.querySelector('.quiz-section-option-part-3');
                if (this.state.step === 4) return this.querySelector('.quiz-section-option-part-4');
                return null;
            }

            updateUI() {
                // 1. Update Attributes for CSS hooks
                // This drives the visibility of parts and buttons via CSS
                this.dataset.step = this.state.step;
                if (this.state.subStep) this.dataset.stepPart = this.state.subStep;
                else this.removeAttribute('data-step-part');

                // 2. Update Title
                let titleKey = `${this.state.step}`;
                if (this.state.step === 2 && this.state.subStep) titleKey = `2_${this.state.subStep}`;
                if (this.dom.title) this.dom.title.textContent = this.quizTitls[titleKey] || "";

                // 3. Update Progress Bar
                this.dom.progressBarItems.forEach(item => {
                    const index = parseInt(item.dataset.index);
                    if (index <= this.state.step) item.classList.add('active');
                    else item.classList.remove('active');
                });

                // 4. Update Next Button State
                this.updateNextButtonState();

                if (this.state.step === 4) {
                    if (!this._step4ImpressionSent) {
                        const moduleName = 'quiz_step4';
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ event_parameters: null });
                        window.dataLayer.push({
                            event: 'ga4Event',
                            event_name: 'module_impression',
                            event_parameters: {
                                module: moduleName
                            }
                        });
                        this._step4ImpressionSent = true;
                    }
                } else {
                    this._step4ImpressionSent = false;
                }
            }

            updateNextButtonState() {
                if (!this.dom.nextBtn) return;

                // If we are at the result step (step 4), we might not need to check selection
                // or the button might be hidden via CSS. 
                // But generally, we only check selection for steps 1, 2, 3.
                if (this.state.step >= 4) {
                    // Assuming step 4 doesn't use the next button in the same way, 
                    // or it's hidden. We can leave it as is or disabled.
                    // For now, let's keep it enabled or ignore, assuming CSS hides it.
                    // But to be safe and strictly follow "check if at least one option is selected",
                    // we'll apply the logic if step < 4.
                    return;
                }

                const currentPart = this.getCurrentPart();
                // Check if any visible button in the current part is selected
                // Note: filterStep3Options removes 'selected' class from hidden buttons,
                // so we just need to check for .selected class.
                const hasSelection = currentPart && currentPart.querySelector('.quiz-section-option-button.selected');

                if (hasSelection) {
                    this.dom.nextBtn.removeAttribute('disabled');
                } else {
                    this.dom.nextBtn.setAttribute('disabled', 'true');
                }
            }

            mapStep2Category(group, label) {
                const g = this.normalize(group);
                const l = this.normalize(label);
                if (g === this.normalize('Sport')) {
                    if (l.includes('running')) return 'run';
                    if (l.includes('cycling')) return 'cycling';
                    if (l.includes('training') || l.includes('gym')) return 'traning / gym';
                    if (l.includes('hiking') || l.includes('climbing')) return 'hiking / climbing';
                    if (l.includes('swimming')) return 'swimming';
                }
                if (g === this.normalize('Lifestyle') || g === this.normalize('Multi-scenario use')) {
                    if (l.includes('music podcasts')) return 'music / podcasts';
                    if (l.includes('light exercise') || l.includes('walking') || l.includes('gym')) return 'light exercise / walking / gym';
                    if (l.includes('running') || l.includes('cycling')) return 'running / cycling';
                    if (l.includes('mobile calls')) return 'mobile calls';
                    if (l.includes('reading') || l.includes('office work')) return 'reading / office work';
                }
                if (g === this.normalize('Work')) {
                    if (l.includes('all day comfort')) return 'all-day comfort';
                    if (l.includes('clear calling')) return 'clear calling';
                    if (l.includes('noise reduction')) return 'noise reduction';
                }
                return null;
            }

            filterStep3Options() {
                const step1Label = this.state.labels['1'];
                const groupKey = (() => {
                    const s1 = this.normalize(step1Label);
                    if (s1 === this.normalize('Sport')) return 'sport';
                    if (s1 === this.normalize('Lifestyle')) return 'lifestyle';
                    if (s1 === this.normalize('Multi-scenario use')) return 'multi-scenario use';
                    if (s1 === this.normalize('Work')) return 'work';
                    return null;
                })();
                const step2KeyRaw = (() => {
                    if (groupKey === 'sport') return this.state.labels['2_1'] || '';
                    if (groupKey === 'lifestyle' || groupKey === 'multi-scenario use') return this.state.labels['2_2'] || '';
                    if (groupKey === 'work') return this.state.labels['2_3'] || '';
                    return '';
                })();
                const categoryKey = this.mapStep2Category(step1Label, step2KeyRaw);
                const groupObj = groupKey ? this.productMap[groupKey] : null;
                const resolvedCatKey = groupObj ? Object.keys(groupObj).find(k => this.normalize(k) === this.normalize(categoryKey)) : null;
                let allowedNeeds = resolvedCatKey ? Object.keys(groupObj[resolvedCatKey]) : [];
                const part3 = this.querySelector('.quiz-section-option-part-3');
                const step3Buttons = this.querySelectorAll('.quiz-section-option-part-3 .quiz-section-option-button');
                const hidden = [];
                const shown = [];

                if (allowedNeeds.length === 0) {
                    const s1 = this.normalize(step1Label);
                    const s2 = this.normalize(step2KeyRaw || '');
                    if (s1 === this.normalize('Sport')) {
                        if (s2.includes('swim')) {
                            allowedNeeds = ['land & water use', 'built-in mp3', 'price / value'];
                        } else {
                            allowedNeeds = ['sound quality', 'all-day comfort', 'secure fit', 'sweat resistance', 'price / value'];
                        }
                    } else if (s1 === this.normalize('Lifestyle') || s1 === this.normalize('Multi-scenario use')) {
                        if (s2.includes('music') && s2.includes('podcasts')) {
                            allowedNeeds = ['sound quality', 'all-day comfort', 'secure fit', 'price / value'];
                        } else if (s2.includes('light exercise') || s2.includes('walking') || s2.includes('gym')) {
                            allowedNeeds = ['sound quality', 'all-day comfort', 'secure fit', 'price / value', 'sweat resistance'];
                        } else if (s2.includes('running') || s2.includes('cycling')) {
                            allowedNeeds = ['sound quality', 'all-day comfort', 'secure fit', 'price / value', 'sweat resistance'];
                        } else if (s2.includes('mobile calls')) {
                            allowedNeeds = ['sound quality', 'all-day comfort', 'secure fit', 'price / value'];
                        } else if (s2.includes('reading') || s2.includes('office work')) {
                            allowedNeeds = ['sound quality', 'all-day comfort', 'secure fit', 'price / value'];
                        }
                    } else if (s1 === this.normalize('Work')) {
                        allowedNeeds = []; // Work 路径不显示 Step3
                    }
                }
                // if (this.DEBUG) console.log(`[Quiz] Step3允许的需求项: ${allowedNeeds.join(', ') || '(无)'}`);
                const allowedSetFinal = new Set(allowedNeeds.map(n => this.normalize(n)));

                step3Buttons.forEach(btn => {
                    const needRaw = btn.getAttribute('data-needs') || (btn.querySelector('.quiz-section-option-button-text')?.textContent || btn.textContent);
                    const need = this.normalize(needRaw);
                    const allow = allowedSetFinal.size > 0 && allowedSetFinal.has(need);
                    if (allow) {
                        btn.removeAttribute('data-hidden');
                        shown.push(needRaw);
                    } else {
                        btn.setAttribute('data-hidden', 'true');
                        btn.classList.remove('selected');
                        hidden.push(needRaw);
                    }
                });


                if (part3) {
                    if (shown.length === 0) part3.setAttribute('data-empty', 'true');
                    else part3.removeAttribute('data-empty');
                }
                // if (this.DEBUG) console.log(`[Quiz] Step3显示: ${shown.join(', ') || '(无)'}；隐藏: ${hidden.join(', ') || '(无)'}`);
            }

            calculateAndShowResult() {
                const step1Label = this.state.labels['1'];
                const groupKey = (() => {
                    const s1 = this.normalize(step1Label);
                    if (s1 === this.normalize('Sport')) return 'sport';
                    if (s1 === this.normalize('Lifestyle')) return 'lifestyle';
                    if (s1 === this.normalize('Multi-scenario use')) return 'multi-scenario use';
                    if (s1 === this.normalize('Work')) return 'work';
                    return null;
                })();

                const step2KeyRaw = this.state.labels['2_1'] || this.state.labels['2_2'] || this.state.labels['2_3'];
                const categoryKey = this.mapStep2Category(step1Label, step2KeyRaw);
                const needKey = this.state.labels['3'];

                let productName = null;
                if (groupKey === 'work') {
                    const step2RawLabel = this.state.rawLabels ? (this.state.rawLabels['2_3'] || this.state.rawLabels['2_2'] || this.state.rawLabels['2_1'] || '') : '';
                    const workObj = this.productMap['work'];
                    const resolvedWorkCatKey = Object.keys(workObj).find(k => this.normalize(k) === this.normalize(step2RawLabel));
                    productName = resolvedWorkCatKey ? workObj[resolvedWorkCatKey] : null;
                } else {
                    if (groupKey && categoryKey && needKey) {
                        const groupObj = this.productMap[groupKey];
                        const resolvedCatKey = Object.keys(groupObj).find(k => this.normalize(k) === this.normalize(categoryKey));
                        const catObj = resolvedCatKey ? groupObj[resolvedCatKey] : null;
                        if (catObj) {
                            const resolvedNeedKey = Object.keys(catObj).find(k => this.normalize(k) === this.normalize(needKey));
                            productName = resolvedNeedKey ? catObj[resolvedNeedKey] : null;
                        }
                    }
                }

                const handle = productName ? this.handleMap[this.normalize(productName)] || this.handleMap[productName] : 'openrun-pro2';

                // Activate the product
                let found = false;
                this.dom.resultProducts.forEach(product => {
                    product.classList.remove('active');

                    if (!found && product.dataset.handle === handle) {
                        product.classList.add('active');
                        found = true;
                    }
                });

                // Fallback if specific handle not found, show the first available one
                if (!found && this.dom.resultProducts.length > 0) {
                    this.dom.resultProducts[0].classList.add('active');
                }
            }

            getActiveVariantId() {
                const active = this.querySelector('.quiz-section-result-product-item.active');
                return active ? (active.dataset.variantId || '') : '';
            }

            prepareSubscribePayload() {
                const habitRaw = this.state.rawLabels ? this.state.rawLabels['1'] : '';
                const step2Raw = this.state.rawLabels ? (this.state.rawLabels['2_1'] || this.state.rawLabels['2_2'] || this.state.rawLabels['2_3'] || '') : '';
                const step3Raw = this.state.rawLabels ? this.state.rawLabels['3'] : '';
                const isWork = this.normalize(habitRaw) === this.normalize('Work');
                const payload = {
                    quiz_habit: habitRaw || '',
                    quiz_scenario: isWork ? '' : (step2Raw || ''),
                    quiz_needs: isWork ? (step2Raw || '') : (step3Raw || ''),
                    quiz_varientid: this.getActiveVariantId()
                };
                return payload;
            }

            bindEvents() {
                this.querySelectorAll('.quiz-section-option-button').forEach(button => {
                    button.addEventListener('click', (e) => this.handleOptionClick(e));
                });

                if (this.dom.nextBtn) this.dom.nextBtn.addEventListener('click', () => this.nextStep());
                if (this.dom.backBtn) this.dom.backBtn.addEventListener('click', () => this.prevStep());
                if (this.dom.restartBtn) this.dom.restartBtn.addEventListener('click', () => this.restart());
                if (this.dom.linkBtn) {
                    this.dom.linkBtn.addEventListener('click', () => {
                        if (this.state.step === 4) {
                            const buttonName = (this.dom.linkBtn.getAttribute('aria-label') || this.dom.linkBtn.textContent || '').trim();
                            this.ga4SelectContent('quiz_step4', 'quiz_recommend', buttonName);
                        }
                    });
                }

                this.querySelectorAll('.quiz-section-result-product-item a').forEach(a => {
                    a.addEventListener('click', (e) => {
                        const anchor = e.currentTarget;
                        const isBuy = anchor.classList.contains('quiz-section-button_buy');
                        const source = isBuy ? 'link' : 'picture';
                        const eventName = 'select_item';
                        const $ = window.jQuery || window.$;
                        if ($) {
                            this.trackBuyCardClick($(anchor), source, eventName);
                        }
                    });
                });

                if (this.dom.subscribeForm) {
                    this.dom.subscribeForm.addEventListener('submit', (e) => {
                        e.preventDefault();
                        const p = this.prepareSubscribePayload();
                        const emailInput = this.dom.subscribeForm.querySelector('input[name="email"]');
                        const email = emailInput ? emailInput.value.trim() : '';
                        const btn = this.dom.subscribeForm.querySelector('.quiz-section-button_subscribe');
                        if (btn) {
                            btn.disabled = true;
                            btn.classList.add('is-loading');
                        }
                        const url = 'https://global.shokz.com/api/v1/quiz/submit';
                        const site = (this.dom.subscribeForm?.dataset?.site || this.dom.subscribeForm?.getAttribute('data-site') || 'uk').trim();
                        let subscribeStatus = 'fail';
                        const payload = {
                            email,
                            quiz_habit: p.quiz_habit,
                            quiz_scenario: p.quiz_scenario,
                            quiz_needs: p.quiz_needs,
                            quiz_varientid: p.quiz_varientid
                        };
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'X-Site': site
                            },
                            body: JSON.stringify(payload),
                            credentials: 'omit',
                            mode: 'cors'
                        }).then(async (res) => {
                            let msg = 'Submitted';
                            let code = null;
                            try {
                                const data = await res.json();
                                code = typeof data?.code === 'number' ? data.code : null;
                                if (!res.ok) {
                                    msg = data?.message || 'Submit failed';
                                    subscribeStatus = (msg && String(msg).toLowerCase() === 'success') ? 'success' : 'fail';
                                } else if (code !== null && code !== 0) {
                                    msg = data?.message || `Error code ${code}`;
                                    subscribeStatus = (msg && String(msg).toLowerCase() === 'success') ? 'success' : 'fail';
                                } else {
                                    subscribeStatus = (msg && String(msg).toLowerCase() === 'success') ? 'success' : 'success';
                                }
                            } catch (_) {
                                if (!res.ok) msg = 'Submit failed';
                                subscribeStatus = 'fail';
                            }
                            if (!res.ok || (code !== null && code !== 0)) {
                                // alert(msg);
                            } else {
                                // alert('Success');
                                this.dom.subscribeContainer.classList.add('active');
                                setTimeout(() => {
                                    this.dom.subscribeContainer.classList.remove('active');
                                }, 5000);
                            }
                        }).catch(() => {
                            alert('Network error');
                            subscribeStatus = 'fail';
                        }).finally(() => {
                            if (btn) {
                                btn.disabled = false;
                                btn.classList.remove('is-loading');
                            }
                            const moduleName = 'springsale_subscription';
                            const contentName = 'quiz_step4';
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({ event_parameters: null });
                            window.dataLayer.push({
                                event: 'ga4Event',
                                event_name: 'subscribe',
                                event_parameters: {
                                    module: moduleName,
                                    status: subscribeStatus,
                                    email: email,
                                    content_name: contentName
                                }
                            });
                        });
                    });
                }
            }
        }
    )
}
